import { render, staticRenderFns } from "./CtaInlineModule.vue?vue&type=template&id=fdfef852&"
import script from "./CtaInlineModule.ts?vue&type=script&lang=ts&"
export * from "./CtaInlineModule.ts?vue&type=script&lang=ts&"
import style0 from "./CtaInlineModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports